enum ListType {
  standard="standard",
  shortList="shortList",
  longList="longList",
  dynamic="dynamic",
}
export default ListType;
